import { PROGRAM_SCHEMA_VERSION, type Program } from "@heraion/shared";
import {
  usePrograms,
  useProgramFollowGate,
  type ProgressByProgram,
} from "@heraion/ui";

import { apiFetch } from "./api";
import { confirmViaWindow } from "./confirm";
import { durableWrite } from "./durableWrite";
import { lsCache } from "./lsCache";

// Stable cache adapters (created once) so web has the same cache-first
// programs/progress backstop mobile gets from AsyncStorage.
// #498: keyed by PROGRAM_SCHEMA_VERSION, like mobile's 'plan/programs': a
// copy parsed by an older build lacks the fields it did not know, and must
// not seed an editor that saves at the new version.
const programsLsCache = lsCache<Program[]>(`jl.programs.v${PROGRAM_SCHEMA_VERSION}`);
export const progressLsCache = lsCache<ProgressByProgram>("jl.programsProgress.v1");

// The athlete's programs with the follow gate, on web: the Home surface and
// the Create hub's «today» card (AP-9b) read the same buckets through the same
// caches. Mobile's twin is useProgramsData.
export function useFollowedPrograms() {
  // What the caller FOLLOWS (next/coaching.md, "La SPEC del follower"): it
  // buckets a followed program as followed whatever status its author left
  // it in, and it makes that card read-only.
  const followGate = useProgramFollowGate({
    apiFetch,
    durableWrite,
    confirm: confirmViaWindow,
  });
  const programsState = usePrograms({
    apiFetch,
    durableWrite,
    withProgress: true,
    programsCache: programsLsCache,
    progressCache: progressLsCache,
    followedProgramIds: followGate.followedProgramIds,
  });
  return { followGate, programsState };
}
